function addToCartCustom(e, url_preventivo) {
  let u1 = url_preventivo;
  event.preventDefault();
  fetch(window.Shopify.routes.root + "cart.js")
    .then((cart_response) => cart_response.json())
    .then((cart_response_json) => {
      let listorder = cart_response_json.items.length + 1;
      let elements = document.getElementsByClassName(
        "additional-product-quantity-input"
      );
      const main_product = {
        quantity: 1,
        product_id: product.id,
        id: variant.id,
        key: listorder,
        properties: {
          type: "product",
          listorder: listorder,
          related_products: [],
        },
      };
      const obj = {
        items: [main_product],
        form_type: "product",
      };
      // accessori.
      for (let o of elements) {
        if (o && o.value > 0) {
          listorder++;
          const v1 = o.id.replaceAll("item_", "").split("-");
          let sub_variant_id = parseInt(v1[1]);
          let sub_product_id = parseInt(v1[0]);
          let qty = o.value;
          main_product.properties.related_products.push(listorder);
          obj.items.push({
            quantity: qty,
            product_id: sub_product_id,
            variant_id: sub_variant_id,
            key: listorder,
            id: sub_variant_id,
            properties: {
              listorder: listorder,
              title: o.attributes["data-title"],
              type: "accessori",
              main_product: main_product.properties.listorder,
            },
          });
        }
      }
      // opzione di spedizione.
      let opzioniSpedizione = document.getElementsByName(
        "opzioni-di-spedizione"
      );
      let spedizioneId = "";
      for (let o of opzioniSpedizione) {
        if (o.checked) {
          spedizioneId = o.value;
          break;
        }
      }

      if (spedizioneId != "") {
        listorder++;
        const v1 = spedizioneId.split("-");
        let sub_variant_id = parseInt(v1[1]);
        let sub_product_id = parseInt(v1[0]);
        if (v1.length == 3 && v1[2] != "") {
          window.location = u1 ? u1 : "/";
          return;
        }

        obj.items.push({
          quantity: 1,
          product_id: sub_product_id,
          variant_id: sub_variant_id,
          id: sub_variant_id,
          properties: {
            type: "spedizioni",
            listorder: listorder,
            main_product: main_product.properties.listorder,
          },
        });
        main_product.properties.related_products.push(listorder);
      }
      // serratura
      let serratura_node = $("#serratura").find(":selected");
      if (serratura_node) {
        let serratura = serratura_node.val();
        if (serratura) {
          listorder++;
          const v1 = serratura.split("-");
          let sub_variant_id = parseInt(v1[1]);
          let sub_product_id = parseInt(v1[0]);
          obj.items.push({
            quantity: 1,
            product_id: sub_product_id,
            variant_id: sub_variant_id,
            id: sub_variant_id,
            properties: {
              type: "serrature",
              listorder: listorder,
              main_product: main_product.properties.listorder,
            },
          });
          main_product.properties.related_products.push(listorder);
        }
      }

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
      })
        .then((response) => response.json())
        .then((cart) => {
          ajaxCart.load();
          vela.drawerCart.open();
        });
    });
}

function find_cart_item_by_line_id(cart, line_id) {
  for (let p of cart.items) {
    if (p.properties.listorder == line_id) return p;
  }
  return null;
}
function removeItemCart(line_id, callback) {
  event.preventDefault();

  fetch(window.Shopify.routes.root + "cart.js")
    .then((cart_response) => cart_response.json())
    .then((cart_response_json) => {
      let p = find_cart_item_by_line_id(cart_response_json, line_id);
      if (!p) return;

      let main_product = false;

      let item_ids_to_change = [];
      if (p.properties.type == "product") {
        item_ids_to_change = p.properties.related_products;
        item_ids_to_change.push(p.properties.listorder);
        main_product = Object.assign(p);
      } else {
        let main = find_cart_item_by_line_id(
          cart_response_json,
          p.properties.main_product
        );
        main_product = Object.assign(main);
        item_ids_to_change = main.properties.related_products;
        item_ids_to_change.push(main.properties.listorder);
      }
      let keys_to_delete = {};
      for (let id of item_ids_to_change) {
        for (let p of cart_response_json.items) {
          if (p.properties.listorder == id) {
            keys_to_delete[p.key] = 0;
          }
        }
      }
      let update_obj_request = {
        updates: keys_to_delete,
      };

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(update_obj_request),
      })
        .then((response) => response.json())
        .then((cart) => {
          if (callback) {
            callback(main_product);
          } else {
            ajaxCart.load();
            vela.drawerCart.open();
          }
        });
    });
}

function removeSubItemCart(line_id) {
  event.preventDefault();

  fetch(window.Shopify.routes.root + "cart.js")
    .then((cart_response) => cart_response.json())
    .then((cart_response_json) => {
      let p = find_cart_item_by_line_id(cart_response_json, line_id);
      let keys_to_delete = {};
      keys_to_delete[p.key] = 0;
      let update_obj_request = {
        updates: keys_to_delete,
      };

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(update_obj_request),
      })
        .then((response) => response.json())
        .then((cart) => {
          ajaxCart.load();
          vela.drawerCart.open();
        });
    });
}

function updateAdditionalProductQuantity(checkbox) {
  const id = checkbox.id.split("_")[1];
  const quantityInput = $(checkbox)
    .parent()
    .parent()
    .find("#item_" + id)[0];
  if (checkbox.checked) {
    quantityInput.value = "1";
  } else {
    quantityInput.value = "0";
  }
}
function updateAdditionalProductQuantityItem(checkbox) {
  const ids = checkbox.id.split("_");
  const quantityInput = $(checkbox)
    .parent()
    .parent()
    .find("#item_" + ids[1] + "_" + ids[2])[0];
  if (checkbox.checked) {
    quantityInput.value = "1";
  } else {
    quantityInput.value = "0";
  }
}

function validateAdditionalProductCheckbox(quantityInput) {
  const id = quantityInput.id.split("_")[1];
  const checkbox = $(quantityInput)
    .parent()
    .parent()
    .find("#ch_" + id)[0];

  if (quantityInput.value === "0") {
    checkbox.checked = false;
  } else {
    checkbox.checked = true;
  }
}

Handlebars.registerHelper("ifeq", function (a, b, options) {
  if (a == b) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper("ifCond", function (v1, v2, options) {
  if (v1 === v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper("ifin", function (a, b, options) {
  if (a && b.indexOf(a) !== -1) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper("ifnotin", function (a, b, options) {
  if (!a || b.split(",").indexOf(a) === -1) {
    return options.fn(this);
  }
  return options.inverse(this);
});

function changeCartItem(obj, id) {
  event.preventDefault();
  removeItemCart(id, (main_product) => {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((cart_response) => cart_response.json())
      .then((cart_response_json) => {
        let listorder = cart_response_json.items.length + 1;

        let elements = document.getElementsByClassName(
          "additional-product-quantity-input-" + id
        );
        let opzioniSpedizione = document.getElementsByName(
          "opzioni-di-spedizione-" + id
        );
        let all = [];

        delete main_product.key;
        main_product.properties.listorder = listorder;
        main_product.properties.related_products = [];
        all.push(main_product);

        // accessori
        for (let o of elements) {
          if (o) {
            listorder++;
            const itemId = o.id.replaceAll("item_" + id + "_", "");
            const v1 = itemId.split("-");
            let sub_variant_id = parseInt(v1[1]);
            let sub_product_id = parseInt(v1[0]);
            let qty = o.value;
            if (qty > 0) {
              all.push({
                quantity: qty ? parseInt(qty) : 0,
                product_id: sub_product_id,
                variant_id: sub_variant_id,
                id: sub_variant_id,
                properties: {
                  listorder: listorder,
                  title: o.attributes["data-title"],
                  type: "accessori",
                  main_product: main_product.properties.listorder,
                },
              });
              main_product.properties.related_products.push(listorder);
            }
          }
        }
        // spedizione
        let spedizioneId = "";
        for (let o of opzioniSpedizione) {
          if (o.checked) {
            spedizioneId = o.value;
            break;
          }
        }

        listorder++;
        const v1 = spedizioneId.split("-");
        let sub_variant_id = parseInt(v1[1]);
        let sub_product_id = parseInt(v1[0]);
        if (v1[2] != "") {
          window.location = "/";
          return;
        }
        let spedizione = {
          quantity: main_product.quantity,
          product_id: sub_product_id,
          variant_id: sub_variant_id,
          id: sub_variant_id,
          properties: {
            type: "spedizioni",
            listorder: listorder,
            main_product: main_product.properties.listorder,
          },
        };
        main_product.properties.related_products.push(listorder);
        all.push(spedizione);

        // serratura.
        let serratura_node = $("#serratura_" + id).find(":selected");
        if (serratura_node) {
          let serratura = serratura_node.val();
          if (serratura) {
            listorder++;
            const v1 = serratura.split("-");
            let sub_variant_id = parseInt(v1[1]);
            let sub_product_id = parseInt(v1[0]);
            all.push({
              quantity: 1,
              product_id: sub_product_id,
              variant_id: sub_variant_id,
              id: sub_variant_id,
              properties: {
                type: "serrature",
                listorder: listorder,
                main_product: main_product.properties.listorder,
              },
            });
            main_product.properties.related_products.push(listorder);
          }
        }
        let update_obj_request = {
          items: all,
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(update_obj_request),
        })
          .then((response) => response.json())
          .then((data) => {
            location.reload();
          });
      });
  });
}

function onCheckFatturaSiNo(id) {
  let fattura_si = $("input[name=fattura_si]:checked").val();
  console.log(fattura_si);
  //$("#presubmitButton").addClass('disabled');
  if (id == 1) {
    // privato
    $("#form_fields").addClass("form_hidden");
    $("#form_fields2").removeClass("form_hidden");
    $("input[name=codicefiscale_priv]").prop("disabled", false);
    $("input[name=codicefiscale]").prop("disabled", true);
    $("input[name=piva]").prop("disabled", true);
    $("input[name=sdi]").prop("disabled", true);
    $("input[name=ragionesociale]").prop("disabled", true);
    //$("input[name=indirizzo]").prop('disabled', true);
  } else {
    $("#form_fields").removeClass("form_hidden");
    $("#form_fields2").addClass("form_hidden");
    $("input[name=codicefiscale_priv]").prop("disabled", true);
    $("input[name=codicefiscale]").prop("disabled", false);
    $("input[name=piva]").prop("disabled", false);
    $("input[name=sdi]").prop("disabled", false);
    $("input[name=ragionesociale]").prop("disabled", false);
    //$("input[name=indirizzo]").prop('disabled', false);
  }
}
function validatePresubmitFields() {
  let form = document.getElementById("presubmit_form");
  let fattura_si = $("input[name=fattura_si]:checked").val();
  let codicefiscale = "";
  if (fattura_si == 1) {
    codicefiscale = $("input[name=codicefiscale_priv]").val();
  } else {
    codicefiscale = $("input[name=codicefiscale]").val();
  }
  let piva = $("input[name=piva]").val();
  let sdi = $("input[name=sdi]").val();
  let condizioni_spedizione = $("input[name=condizioni_spedizione]").prop(
    "checked"
  );
  let ragionesociale = $("input[name=ragionesociale]").val();
  //let indirizzo = $("input[name=indirizzo]").val();
  if (condizioni_spedizione) {
    if (fattura_si == 1) {
      if (codicefiscale) {
        $("#presubmitButton").removeClass("disabled");
      }
    } else {
      if (codicefiscale && sdi && piva && ragionesociale) {
        $("#presubmitButton").removeClass("disabled");
      }
    }
  } else {
    $("#presubmitButton").addClass("disabled");
  }
}
function sendCartForm() {
  event.preventDefault();

  let form = document.getElementById("presubmit_form");
  let fattura_si = $("input[name=fattura_si]:checked").val();

  let codicefiscale = "";
  if (fattura_si == 1) {
    codicefiscale = $("input[name=codicefiscale_priv]").val();
  } else {
    codicefiscale = $("input[name=codicefiscale]").val();
  }
  let piva = $("input[name=piva]").val();
  let sdi = $("input[name=sdi]").val();
  let ragionesociale = $("input[name=ragionesociale]").val();
  //let indirizzo = $("input[name=indirizzo]").val();
  let notes = $("input[name=notes]").val();

  if ((codicefiscale && sdi && piva && ragionesociale) || fattura_si == 1) {
    let obj = {
      attributes: {
        fattura_si: fattura_si,
        codicefiscale: codicefiscale,
        piva: piva,
        sdi: sdi,
        ragionesociale: ragionesociale,
        //indirizzo: indirizzo
      },
      note: notes,
    };
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then((data) => {
        let main_form = document.getElementById("cart");
        if (main_form) {
          $(main_form)
            .append("<input type=hidden name=checkout form=cart>")
            .submit();
        } else {
          let main_form = document.getElementById("ajaxcartform");
          $(main_form)
            .append("<input type=hidden name=checkout form=ajaxcartform>")
            .submit();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    alert("Dati non validi");
  }
}

function drawer_check_fattura(e) {}
function drawer_checkout_click(e) {
  var e = window.event;
  vela.drawerCart.close(e);
  fetch(window.Shopify.routes.root + "cart.js")
    .then((cart_response) => cart_response.json())
    .then((cart_response_json) => {
      validatePresubmitFields();
      $("#modal_presubmit_cart").modal("show");

      let form = $("#presubmit_form");
      if (form) {
        let f = form[0];
        f.elements["fattura_si"].value = cart_response_json.attributes
          ? cart_response_json.attributes.fattura_si || false
          : false;
        f.elements["ragionesociale"].value = cart_response_json.attributes
          ? cart_response_json.attributes.ragionesociale || ""
          : "";
        f.elements["piva"].value = cart_response_json.attributes
          ? cart_response_json.attributes.piva || ""
          : "";
        f.elements["codicefiscale"].value = cart_response_json.attributes
          ? cart_response_json.attributes.codicefiscale || ""
          : "";
        f.elements["codicefiscale_priv"].value = cart_response_json.attributes
          ? cart_response_json.attributes.codicefiscale || ""
          : "";
        f.elements["sdi"].value = cart_response_json.attributes
          ? cart_response_json.attributes.sdi || ""
          : "";
        //f.elements['indirizzo'].value = cart_response_json.attributes ? (cart_response_json.attributes.indirizzo || '') : '';
        //f.elements['notes'].value = cart_response_json.note;
      }
      // riempi i campi in base al carrello.
    });
}

function main_cart_check_fattura(e) {}
function main_cart_checkout(e) {
  let fattura_si = $("input[name=fattura_si]").val();

  fetch(window.Shopify.routes.root + "cart.js")
    .then((cart_response) => cart_response.json())
    .then((cart_response_json) => {
      validatePresubmitFields();
      $("#modal_presubmit_cart").modal("show");

      let form = $("#presubmit_form");
      if (form) {
        let f = form[0];
        f.elements["fattura_si"].value = cart_response_json.attributes
          ? cart_response_json.attributes.fattura_si
          : 0;
        f.elements["ragionesociale"].value = cart_response_json.attributes
          ? cart_response_json.attributes.ragionesociale || ""
          : "";
        f.elements["piva"].value = cart_response_json.attributes
          ? cart_response_json.attributes.piva || ""
          : "";
        f.elements["codicefiscale"].value = cart_response_json.attributes
          ? cart_response_json.attributes.codicefiscale || ""
          : "";
        f.elements["codicefiscale_priv"].value = cart_response_json.attributes
          ? cart_response_json.attributes.codicefiscale || ""
          : "";
        f.elements["sdi"].value = cart_response_json.attributes
          ? cart_response_json.attributes.sdi || ""
          : "";
        //f.elements['indirizzo'].value = cart_response_json.attributes ? (cart_response_json.attributes.indirizzo || '') : '';
        //f.elements['notes'].value = cart_response_json.note;
      }
      // riempi i campi in base al carrello.
    });
}

function expandProductDescription(button) {
  button.parentElement.classList.toggle("expanded");
}

$(document).ready(() => {
  $("a.spin-up-itemmodify").click((e) => {
    e.preventDefault();
    let id = "#" + e.target.attributes["data-id"].value;
    let qty_input = $(id);
    let v = qty_input.val() ? parseInt(qty_input.val()) : 0;
    let value = v + 1;
    qty_input.val(value);
    $(id.replace("item_", "ch_"))[0].checked = value != 0;
  });
  $("a.spin-down-itemmodify").click((e) => {
    e.preventDefault();
    let id = "#" + e.target.attributes["data-id"].value;
    let qty_input = $(id);
    let v = qty_input.val() ? parseInt(qty_input.val()) : 0;
    let value = v > 0 ? v - 1 : 0;
    qty_input.val(value);
    $(id.replace("item_", "ch_"))[0].checked = value != 0;
  });
});
